import { Heading, TextField, Button, Flex, Link } from "@aws-amplify/ui-react";

export default function Name({
  clientData,
  campaignName,
  setCampaignName,
  campaignId,
  handleSubmit,
  loading,
  navigate,
}) {
  return (
    <>
      <br />
      <br />
      {clientData &&
      clientData.subscriptionPlan &&
      clientData.subscriptionPlan !== "none" ? (
        <>
          <Heading level={4}>Step 1: Campaign Name</Heading>
          <TextField
            placeholder="Enter campaign name"
            value={campaignName}
            onChange={(e) => setCampaignName(e.target.value)}
          />
          <br />
          <Button
            onClick={() => handleSubmit(campaignId ? "update" : "create")}
            isLoading={loading}
            variation="primary"
            marginTop="1rem"
          >
            Save Campaign
          </Button>
        </>
      ) : (
        <Flex justifyContent="center">
          <small>
            <br />
            Unlock with subscription{" "}
            <Link href="" onClick={() => navigate("/billing")}>
              <u>here</u>
            </Link>
            <br />
            <br />
          </small>
        </Flex>
      )}
    </>
  );
}
